module.exports = __webpack_public_path__ + "img/mm.16efd971.svg";